import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MeDto, UpdateMeInput } from '@zoxo/shared';

import { api } from '../../lib/api';

/**
 * 프로필 수정 (PATCH /users/me) — 닉네임·회사명·관심 지역. 회사명은 원문을 보내고 서버가
 * 정규화·초성을 만든다(온보딩과 같은 길). 성공하면 돌아온 MeDto 를 ['me'] 캐시에 바로 쓴다.
 */
export function useUpdateMe() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateMeInput) => api.patch<MeDto>('/users/me', input),
    onSuccess: (me) => {
      queryClient.setQueryData(['me'], me);
    },
  });
}
